import { fetchTableResponse } from "hooks/useTableQuery";

export async function downloadTableFile(url, { signal, filename, format }) {
  // Invoke the picker before awaiting the request to retain the user gesture.
  const handle = window.showSaveFilePicker ? await window.showSaveFilePicker({ suggestedName: filename,
    types: [{ description: format === "csv" ? "CSV" : "Excel", accept: format === "csv" ? { "text/csv": [".csv"] } : { "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"] } }],
  }) : null;
  const response = await fetchTableResponse(url, { signal });
  if (handle && response.body) {
    const writable = await handle.createWritable();
    await response.body.pipeTo(writable, { signal });
    return;
  }
  // Existing automatic-download behavior for browsers without file streams.
  const blob = await response.blob();
  if (signal?.aborted) return;
  const href = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = href; link.download = filename; document.body.appendChild(link);
  link.click(); link.remove(); setTimeout(() => URL.revokeObjectURL(href), 100);
}
